import { render, staticRenderFns } from "./brand-form.vue?vue&type=template&id=000271ac&"
import script from "./brand-form.vue?vue&type=script&lang=js&"
export * from "./brand-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports